import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import * as PropTypes from "prop-types";
import classnames from "classnames";
import { makeStyles, withStyles } from "@material-ui/styles";
import styleConstants from "../../../../styleConstants";

const useStyles = makeStyles(theme => ({
  node: {
    "&:hover": {
      cursor: "pointer"
    }
  },
  circle: {
    fill: "rgba(250, 250, 250, 0.8)",
    stroke: styleConstants.colors.gray4,
    strokeWidth: 1,
    strokeMiterlimit: 10,
    transition: "fill 0.3s ease-in-out"
  },
  text: {
    fill: styleConstants.colors.gray6,
    fontSize: "0.75rem",
    transition: "fill 0.3s ease-in-out"
  }
}));

const StyledTooltip = withStyles(theme => ({
  tooltip: {
    boxShadow: `0 0 0.75rem 0 rgba(184, 184, 184, 0.5)`,
    backgroundColor: "white",
    borderRadius: 0,
    fontSize: "0.75rem",
    fontWeight: styleConstants.fontWeights.book,
    color: styleConstants.colors.gray6,
    padding: "0.5rem",
    "& > h4": {
      padding: 0,
      margin: 0,
      fontSize: "0.75rem",
      fontWeight: styleConstants.fontWeights.bold
    },
    "& > div": {
      "& p": {
        margin: "0.5rem 0 0",
        lineHeight: styleConstants.fonts.headingLineHeight
      },
      "& ul": {
        listStyle: "none",
        marginTop: "0.5rem"
      },
      "& a": {
        fontWeight: styleConstants.fontWeights.medium,
        color: styleConstants.colors.themeBlue,
        "&:hover": {
          color: styleConstants.colors.themeBlueMedium
        }
      }
    }
  }
}))(Tooltip);

const Source = props => {
  const classes = useStyles();

  return (
    <StyledTooltip
      interactive
      placement={"top"}
      title={
        <>
          <h4>{props.description.heading}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: props.description.content
            }}
          ></div>
        </>
      }
    >
      <g
        id={props.id}
        className={classnames(
          classes.node,
          props.current === undefined
            ? undefined
            : props.groups.includes(props.current)
            ? "active"
            : "faded"
        )}
        onMouseEnter={props.updateCurrent}
        onMouseLeave={props.removeCurrent}
      >
        <circle
          className={classes.circle}
          cx={props.cx}
          cy={props.cy}
          r={props.r}
        />
        <text
          className={classes.text}
          transform={`translate(${props.tx} ${props.ty})`}
          dangerouslySetInnerHTML={{ __html: props.content }}
        ></text>
      </g>
    </StyledTooltip>
  );
};

Source.propTypes = {
  id: PropTypes.string.isRequired,
  cx: PropTypes.number,
  cy: PropTypes.number,
  r: PropTypes.number,
  tx: PropTypes.number,
  ty: PropTypes.number,
  groups: PropTypes.arrayOf(PropTypes.string),
  content: PropTypes.string
};

Source.defaultProps = {
  cx: 100,
  cy: 100,
  r: 100,
  tx: 100,
  ty: 100,
  groups: undefined,
  content: "Where's the content?"
};

export default Source;
